export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7098.c740104d.jpg";